var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "div",
        { staticClass: "v-height-flag" },
        [
          _c(
            "el-card",
            {
              staticClass: "mb14 normal-page",
              attrs: { "body-style": { padding: "20px 20px 20px 20px" } },
            },
            [
              _vm.search.length > 0
                ? _c("oaFromBox", {
                    attrs: {
                      isViewSearch: false,
                      search: _vm.search,
                      title: "触发器列表",
                      total: _vm.total,
                    },
                    on: {
                      addDataFn: _vm.addFinance,
                      confirmData: _vm.confirmData,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "table-box mt10",
                },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        height: _vm.tableHeight,
                        "row-key": "id",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "触发器名称", prop: "name" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "color-doc pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFn(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(scope.row.name))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          "min-width": 150,
                          label: "触发类型",
                          prop: "field_name",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.getEvent(scope.row.event)) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "触发动作", prop: "form_value" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.action && scope.row.action.length > 0
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.getAction(scope.row.action)
                                          ) +
                                          "\n              "
                                      ),
                                    ])
                                  : _c("span", { staticClass: "color-file" }, [
                                      _vm._v("（无触发动作）"),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "优先级", prop: "sort" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "关联实体",
                          "min-width": "140",
                          prop: "crud",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.crud.table_name || "--") +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "关联应用",
                          "min-width": "140",
                          prop: "cate_item",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.cate_item &&
                                scope.row.cate_item.length > 0
                                  ? _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getString(scope.row.cate_item)
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _c("div", [_vm._v("--")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "更新时间", prop: "updated_at" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "状态", prop: "is_main" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                    width: 60,
                                    "active-text": "开启",
                                    "inactive-text": "关闭",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleStatus(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "status", $$v)
                                    },
                                    expression: "scope.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "操作",
                          prop: "address",
                          width: "110",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.editFn(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteFn(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-fixed" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.where.page,
                          "page-size": _vm.where.limit,
                          "page-sizes": [15, 20, 30],
                          total: _vm.total,
                          layout: "total,sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.pageChange,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          formConfig: _vm.formConfig,
          formDataInit: _vm.formDataInit,
          formRules: _vm.formRules,
          fromData: _vm.fromData,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }